import React from 'react'
import PropTypes from 'prop-types'
import { InputField, LoaderButton } from 'components/molecules'
import { Form, Formik } from 'formik'
import fastSellProductOutboundFormSchema from './fast-sell-product-outbound-form-schema'
import fastSellProductOutboundFormInitialValues from './fast-sell-product-outbound-form-initial-values'


const propTypes = {
  fastSellProduct: PropTypes.shape({
    id                   : PropTypes.number,
    outbound_courier     : PropTypes.string,
    outbound_shipping_no : PropTypes.string,
    status               : PropTypes.string
  }),
  onClickSubmit : PropTypes.func,
  disabled      : PropTypes.bool
}

const defaultProps = {
  fastSellProduct : {},
  onClickSubmit   : () => { },
  disabled        : false
}

const FastSellProductOutboundForm = ({
  onClickSubmit,
  fastSellProduct,
  disabled
}) => (
  <Formik
    initialValues={ fastSellProductOutboundFormInitialValues(fastSellProduct) }
    enableReinitialize={ true }
    validationSchema={ fastSellProductOutboundFormSchema }
    onSubmit={ onClickSubmit }
  >
    {
      (formik) => (
        <Form>
          <InputField
            type={ 'text' }
            name={ 'outbound_courier' }
            label={ 'Outbound Courier' }
            placeholder={ 'JNE / Gojek / J&T' }
            formText={ 'Courier yang digunakan pada pengiriman product' }
            disabled={ disabled }
          />
          <InputField
            type={ 'text' }
            name={ 'outbound_shipping_no' }
            label={ 'Outbound Shipping No' }
            formText={ 'No resi pengiriman' }
            disabled={ disabled }
          />

          <div className='text-right'>
            <LoaderButton
              color='primary'
              type='submit'
              disabled={ formik.isSubmitting || disabled }
              isLoading={ formik.isSubmitting }
              text='Update Outbound'
            />
          </div>
        </Form>
      )
    }
  </Formik>
)

FastSellProductOutboundForm.propTypes    = propTypes
FastSellProductOutboundForm.defaultProps = defaultProps

export default FastSellProductOutboundForm
